import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import BookingTabNavigation from './components/BookingTabNavigation';
import ReceiptReviewQueue from './components/ReceiptReviewQueue';
import PendingBookings from './components/PendingBookings';
import TodayBookings from './components/TodayBookings';

const BookingManagement = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // شناسه سالن به صورت پیش‌فرض یا از لوکال استوریج خوانده می‌شود
  const [selectedSalon] = useState(() => {
    try {
      const stored = localStorage.getItem('@selectedSalon');
      // اگر مقدار معتبر دیتابیسی (طول ۲۴ کاراکتر هگز) نبود، از لیست سالن‌ها برمی‌داریم
      if (stored && stored !== 'salon-0' && stored !== 'main-salon' && stored.length === 24) {
        return stored;
      }

      const salonsRaw = localStorage.getItem('@salons');
      if (salonsRaw) {
        const salons = JSON.parse(salonsRaw);
        if (Array.isArray(salons) && salons.length > 0) {
          const firstSalonId = salons[0]?._id || salons[0]?.id || salons[0]?.value;
          if (firstSalonId && firstSalonId.length === 24) {
            return firstSalonId;
          }
        }
      }
      return '68c806bf374b8c596edb208c'; // fallback اول
    } catch {
      return '68c806bf374b8c596edb208c';
    }
  });

  const [activeTab, setActiveTab] = useState('receipts');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'receipts':
        return <ReceiptReviewQueue salonId={selectedSalon} />;
      case 'pending':
        return <PendingBookings salonId={selectedSalon} />;
      case 'today':
        return <TodayBookings salonId={selectedSalon} />;
      default:
        return <ReceiptReviewQueue salonId={selectedSalon} />;
    }
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      {/* Sidebar - Desktop is fixed, Mobile uses sidebarOpen state */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="lg:mr-60 pt-16 lg:pt-6">
        <div className="p-6 space-y-6">
          {/* Breadcrumbs */}
          <BreadcrumbNavigation />

          {/* Page Title */}
          <div>
            <h1 className="text-2xl font-bold text-foreground mb-1">
              مدیریت رزروها و نوبت‌ها
            </h1>
            <p className="text-sm text-muted-foreground">
              تایید و رد تراکنش‌ها و نوبت‌های سالن به همراه آمار امروز سالن
            </p>
          </div>

          {/* Navigation Tabs */}
          <div className="border-b border-border pb-4">
            <BookingTabNavigation activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          {/* Tab Content Rendering */}
          <div className="min-h-[400px]">
            {renderTabContent()}
          </div>
        </div>
      </main>
    </div>
  );
};

export default BookingManagement;
export { BookingManagement };
